<!-- <app-header
  [navbarBrandRouterLink]="['']"
  [fixed]="true"
  [sidebarToggler]="false"
  [asideMenuToggler]="false"
  [mobileAsideMenuToggler]="false"
  [navbarBrandFull]="{src: 'assets/logoPosV1.svg', width: 30, height: 30, alt: 'Pos Logo'}"
  [navbarBrandMinimized]="{src: 'assets/logoPosV1.svg', width: 30, height: 30, alt: 'Pos Logo'}"
>


</app-header> -->
<div class="app-body">
  <app-sidebar #appSidebar [display]="'lg'" [fixed]="true" [minimized]="sidebarMinimized" *ngIf="showMenu"
    (minimizedChange)="toggleMinimize($event)">
    <div>
      <label class="nav-title bg-light text-black col-sm mt-2"><i class="fa fa-money-bill"></i>&nbsp;USD-HNL:
        {{exchangeRate.rate}}</label>
      <label class="nav-title bg-light text-black col-sm"><i class="fa fa-building"></i>&nbsp;{{salesOrgObject.code}} -
        {{salesOrgObject.name}}</label>
      <label class="nav-title bg-light text-black col-sm"><i class="fa fa-home"></i>&nbsp;{{branchObject.code}} -
        {{branchObject.name}}</label>
      <label class="nav-title bg-light text-black col-sm"><i class="fa fa-cash-register"></i>&nbsp;{{register.code}} -
        {{register.name}}</label>
      <label class="nav-title bg-light text-black col-sm"><i
          class="fa fa-file-invoice"></i>&nbsp;{{fiscalEmissionPoint.fiscalEstablishment}} -
        {{fiscalEmissionPoint.code}}</label>
      <a class="nav-link nav-title" href="javascript:void();" placement="right" container="body"
        [popover]="popTemplateHtml" popoverTitle="Cambio de Tienda" triggers="" #pop="bs-popover"
        (click)="pop.toggle()">
        <i class="nav-icon fa fa-home"></i> Cambiar Tienda
      </a>
      <ng-template #popTemplateHtml>
        <form #f="ngForm" (ngSubmit)="f.valid && changeBranch(pop)">
          <div class="card-body">
            <div class="input-group mb-3 mr-3">
              <div class="input-group-prepend">
                <span class="input-group-text"><i class="fa fa-regular fa-building"></i></span>
              </div>
              <select id="salesOrg" name="salesOrg" class="form-control" [(ngModel)]="salesOrg"
                (change)="filterBranches()">
                <option *ngFor="let salesOrg of salesOrgs" [value]="salesOrg.code">{{salesOrg.code}} - {{salesOrg.name}}
                </option>
              </select>

            </div>
            <div class="input-group mb-3 mr-3">
              <div class="input-group-prepend">
                <span class="input-group-text"><i class="fa fa-home"></i></span>
              </div>
              <!--<select id="select1" name="select1" class="form-control" [(ngModel)]="branch">
            <option value="">Seleccione una Sucursal</option>
            <option *ngFor="let branch of filteredBranches" [value]="branch.code">{{branch.code}} - {{branch.name}}</option>
          </select>-->
              <ng-select id="selectBranches" [items]="filteredBranches" [ngModelOptions]="{standalone: true}"
                [(ngModel)]="branch" [searchable]="true" placeholder="Seleccione una tienda"
                [searchFn]="customSearchBranches">
                <ng-template ng-label-tmp let-item="item">
                  {{item.code}}-{{item.name}}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  <div title="{{item.code}}-{{item.name}}">{{item.code}}-{{item.name}}</div>
                </ng-template>
              </ng-select>
            </div>


            <button type="submit" class="form control btn btn-outline-primary">Cambiar Tienda</button>


          </div>
        </form>
      </ng-template>

    </div>

    <app-sidebar-nav [navItems]="navItems" [perfectScrollbar] [disabled]="appSidebar.minimized">
    </app-sidebar-nav>
    <app-sidebar-minimizer></app-sidebar-minimizer>
  </app-sidebar>

  <main class="main">
    <cui-breadcrumb>
      <!-- Breadcrumb Menu-->
      <ul class="nav ml-auto" *ngIf="showMenu">
        <li class="nav-item mr-3">
          <button [hidden]="!canShowGoToLegacyPOSLink" type="button" class="btn btn-link text-decoration-none p-0 small" data-bs-toggle="tooltip"
            title="Abrir versión anterior del POS (nueva pestaña)" (click)="handleGoToPosLegacyClick()">
            POS Retail
            <i class="fa-solid fa-up-right-from-square fa-xs ms-1"></i>
          </button>
        </li>
        <li class="nav-item mr-3">
          <span class="" href="javascript:void(0);">
            <b>{{register.code}} - {{register.name}}</b>
          </span>
        </li>
        <li class="nav-item mr-3">
          <span class="" href="javascript:void(0);">
            <b>{{fiscalEmissionPoint.fiscalEstablishment}} - {{fiscalEmissionPoint.code}}</b>
          </span>

        </li>
        <li class="nav-item" dropdown placement="bottom right">
          <a class="user-text-clickable px-3 dropdown-toggle" data-toggle="dropdown" href="javascript:void(0);"
            role="button" aria-haspopup="true" aria-expanded="false" [popover]="popTemplateHtml"
            popoverTitle="Cambio de Tienda" triggers="" #popNav="bs-popover" (click)="popNav.toggle()">
            <b>{{branchObject.code}} - {{branchObject.name}}</b>
          </a>

        </li>

        <li class="nav-item dropdown" dropdown placement="bottom right">
          <a class="user-text-clickable  px-3 dropdown-toggle" data-toggle="dropdown" href="#" role="button"
            aria-haspopup="true" aria-expanded="false" dropdownToggle (click)="false">
            <b>[{{profile.username}}] {{profile.fullname}}</b>
          </a>
          <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
            <div class="dropdown-header text-center bg-primary"><strong>Opciones</strong></div>
            <a class="dropdown-item" href="javascript:void(0);" [routerLink]="['/changepassword', profile.username]"><i
                class="fa fa-lock"></i> Cambiar contraseña</a>
          </div>
        </li>

        <ng-template #popTemplateHtml>
          <form #f="ngForm" (ngSubmit)="f.valid && changeBranch(popNav)">
            <div class="card-body">
              <div class="input-group mb-3 mr-3">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fa fa-building-o"></i></span>
                </div>
                <select id="salesOrg" name="salesOrg" class="form-control" [(ngModel)]="salesOrg"
                  (change)="filterBranches()">
                  <option *ngFor="let salesOrg of salesOrgs" [value]="salesOrg.code">{{salesOrg.code}} -
                    {{salesOrg.name}}
                  </option>
                </select>

              </div>
              <div class="input-group mb-3 mr-3">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="cil-home"></i></span>
                </div>
                <!--<select id="select1" name="select1" class="form-control" [(ngModel)]="branch">
              <option value="">Seleccione una Sucursal</option>
              <option *ngFor="let branch of filteredBranches" [value]="branch.code">{{branch.code}} - {{branch.name}}</option>
            </select>-->
                <ng-select id="selectBranches" [items]="filteredBranches" [ngModelOptions]="{standalone: true}"
                  [(ngModel)]="branch" [searchable]="true" placeholder="Selecicone una tienda"
                  [searchFn]="customSearchBranches">
                  <ng-template ng-label-tmp let-item="item">
                    {{item.code}}-{{item.name}}
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    <div title="{{item.code}}-{{item.name}}">{{item.code}}-{{item.name}}</div>
                  </ng-template>
                </ng-select>
              </div>


              <button type="submit" class="form control btn btn-outline-primary">Cambiar Tienda</button>


            </div>
          </form>
        </ng-template>
      </ul>
    </cui-breadcrumb>

    <div class="pos-container">
      <router-outlet></router-outlet>
    </div><!-- /.container-fluid -->
  </main>
</div>
<pos-floating-action-button></pos-floating-action-button>
<app-footer [fixed]="true" class="pos-footer">
  <span>POS v{{version}}</span>
  <span class="ml-auto">Grupo ILP</span>
</app-footer>